export default "__VITE_ASSET__1d11910c__"